import { useLocalization } from '@/shared/composables/localization'

import { Terminal } from '../types'

export const getTerminalNameForDisplay = (terminal: Terminal) => {
  if (terminal.description) {
    return terminal.description
  }

  if (terminal.deviceName) {
    return terminal.deviceName
  }

  const { t } = useLocalization()
  if (terminal.isWebClient) {
    return t('common.webClient')
  }

  let label = ''
  if (terminal.deviceType) {
    if (terminal.deviceType === 'phone') {
      label = t('terminals.phone')
    } else if (terminal.deviceType === 'softPhone') {
      label = t('terminals.softPhone')
    } else if (terminal.deviceType === 'external') {
      label = t('terminals.external')
    } else if (terminal.deviceType === 'combined') {
      label = t('terminals.combined')
    } else if (terminal.deviceType === 'misconfigured') {
      label = t('terminals.misconfigured')
    }
  } else {
    label = t('terminals.terminal')
  }

  return `${label} ${terminal.id}`
}
